"use client";

import {
  ptSerif_body_sm_bold,
  poppins_caption_md_medium,
  poppins_caption_md_semibold,
} from "@frontend/design-system";
import styled, { css } from "styled-components";

export const TooltipBox = styled.div`
  border-radius: 0.4rem;
  border: 1px solid var(--Color-Common-Border-Secondary, #b1b8c4);
  background: var(--Color-Common-Bg-Primary, #fff);

  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.12);

  overflow: hidden;
`;

export const TooltipMonth = styled.div`
  padding: var(--Spacing-4, 0.4rem) var(--Spacing-8, 0.8rem) var(--Spacing-0, 0)
    var(--Spacing-8, 0.8rem);
  gap: var(--Spacing-2, 0.2rem);

  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${ptSerif_body_sm_bold}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: var(--font-pretendard);
`;

export const Row = styled.div<{ $isSelected: boolean }>`
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--Spacing-4, 0.4rem);
  padding: 0.4rem var(--Spacing-8, 0.8rem);

  &:hover {
    background: var(--Color-Common-Bg-Interactive-Selected-Hovered, #d1efff);
  }

  &:active {
    background: var(--Color-Common-Bg-Interactive-Selected-Pressed, #a4dfff);
  }

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background: var(--Color-Common-Bg-Interactive-Selected, #e5f7ff);
    `}
`;

export const TextWrapper = styled.div`
  display: flex;
  gap: 0.2rem;

  .description {
    color: var(--Color-Label-Text-Interactive-Payment, #597181);
  }
`;

export const TooltipDot = styled.div<{
  $backgroundColor: string;
}>`
  width: 1.3rem;
  height: 1.3rem;
  border: 1px solid #fff;
  border-radius: var(--Border-Radius-2, 0.2rem);
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

export const TooltipYear = styled.div`
  color: var(--Color-Common-Text-Secondary, #515c6c);
  ${poppins_caption_md_medium}
`;

export const TooltipAmount = styled.div<{ $isDollars: boolean }>`
  color: #2a2f37;
  ${poppins_caption_md_semibold}
`;

export const TooltipUnit = styled.div`
  ${poppins_caption_md_medium}
  color: #515c6c;
`;

export const TooltipDollars = styled.span`
  color: #515c6c;
  ${poppins_caption_md_semibold}
`;
